export default __webpack_public_path__ + "static/media/target-10@3x.6f0e9035.png";